import { createFileRoute } from "@tanstack/react-router";

import Avatar from "../../../components/Avatar";
import DetailItemCard from "../../../components/DetailItemCard";
import { useAppState } from "../../../contexts/AppContext";
import { capitalizeWords } from "../../../utils";
import { requireRouteAccess } from "../../../utils/authorization";
import { routePaths } from "../../../constants";

export const Route = createFileRoute("/_app/profile/")({
  beforeLoad: () => requireRouteAccess(routePaths.profile),
  component: Profile,
});

function Profile() {
  const {
    state: { user, business },
  } = useAppState();

  const fullName = `${capitalizeWords(user?.firstName ?? "")} ${capitalizeWords(
    user?.lastName ?? "",
  )}`.trim();
  const initials = `${user?.firstName?.[0] ?? ""}${
    user?.lastName?.[0] ?? ""
  }`.toUpperCase();

  return (
    <div className="max-w-2xl">
      <div className="bg-white rounded-lg border border-gray-100 p-6 md:p-8">
        <div className="flex items-center gap-5 mb-8">
          <Avatar characters={initials || "?"} size="lg" disabled />
          <div>
            <h2 className="text-xl font-semibold text-gray-900">{fullName}</h2>
            <p className="text-sm text-gray-500">{user?.email}</p>
          </div>
        </div>

        <div className="space-y-4">
          <DetailItemCard title="Full Name" value={fullName} />
          <DetailItemCard title="Email" value={user?.email ?? "—"} />
          <DetailItemCard
            title="Phone"
            value={
              user?.phone ? `+${user?.diallingCode ?? ""} ${user.phone}` : "—"
            }
          />
          <DetailItemCard
            title="Business Name"
            value={capitalizeWords(business?.name ?? "—")}
          />
          <DetailItemCard
            title="Business Type"
            value={capitalizeWords(business?.businessType ?? "—")}
          />
        </div>
      </div>
    </div>
  );
}
